"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.transformNameToShortName = transformNameToShortName;
function transformNameToShortName(value) {
    const name = value.split(" ")[0];
    const surname = value.split(" ");
    const shortenedSurname = surname
        .filter((s) => s.length > 1)
        .slice(1)
        .map((s) => s.substring(0, 1))
        .join(". ");
    return `${name} ${shortenedSurname}.`;
}
//# sourceMappingURL=transformNameToShortName.js.map